import api from '../../../services/Api';
import { IAuditoriaCambialResultado } from '../interfaces/IAuditoriaCambial';

const resultadoVazio: IAuditoriaCambialResultado = {
  exposicaoFiscalTotalGeral: 0,
  passivoFiscalTotal: 0,
  multaQualificadaTotal: 0,
  multaAcessoriaTotal: 0,
  totalErros: 0,
  totalAlertas: 0,
  totalAvisos: 0,
  status: 'CONCILIADO',
  mensagemDirecionamento: '',
  fundamentacaoLegal: '',
  itens: [],
};

export const AuditoriaCambialService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaCambialResultado> {
    const response = await api.get<IAuditoriaCambialResultado>(
      'auditoria-cambial/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo || '' } },
    );
    return response.data || resultadoVazio;
  },
};
